export var RoleType;
(function (RoleType) {
    RoleType["Inactive"] = "Inactive";
    RoleType["Guest"] = "Guest";
    RoleType["Member"] = "Member";
    RoleType["Admin"] = "Admin";
    RoleType["Owner"] = "Owner";
})(RoleType || (RoleType = {}));
